<template lang="pug">
  .field
    p.control
      span.select.is-small
        select(v-model="value")
          option(v-for="type in types", v-bind:value="type.value") {{type.name}}
    label.label.is-size-7 (http://easings.net/)
</template>
<script>
  import { abstractField } from "vue-form-generator";
  export default {
    props: {
      //value:{
        //type:String,
        //required:true
      //}
    },
    mixins: [ abstractField ],
    data() {
      return {
        types:[
          'linear', 'quadEaseIn', 'quadEaseOut', 'quadEaseInOut', 'easeInQuad',
          'easeOutQuad', 'easeInOutQuad', 'easeInCubic', 'easeOutCubic', 'easeInOutCubic',
          'easeInQuart', 'easeOutQuart', 'easeInOutQuart', 'easeInQuint', 'easeOutQuint',
          'easeInOutQuint', 'easeInSine', 'easeOutSine', 'easeInOutSine', 'easeInExpo',
          'easeOutExpo', 'easeInOutExpo', 'easeInCirc', 'easeOutCirc', 'easeInOutCirc',
          'easeInElastic', 'easeOutElastic', 'easeInOutElastic', 'easeInBack', 'easeOutBack',
          'easeInOutBack', 'easeInBounce', 'easeOutBounce', 'easeInOutBounce',
        ].map( (x) => {
          return {name:x, value:x}
        })
     }
    },
    watch: {
      value() {
        console.log('value changed', this.value);
        this.$emit('input', this.value);
      }
    }
  }
</script>
